// src/services/api.js


  export const authenticateUser = async (dataUrl) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/authenticate-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ image: dataUrl }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to authenticate user');
      }
  
      return response.json();
    } catch (error) {
      console.error('Authentication API error:', error);
      throw error;
    }
  };
  
  export const registerUser = async ({ image, userGuid, firstName, lastName, email }) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/register-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ image, userGuid, firstName, lastName, email }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Registration failed');
      }
  
      return response.json();
    } catch (error) {
      console.error('Register User API error:', error);
      throw error;
    }
  };
  
  
  export const fetchDocuments = async (userGuid, accessToken = null) => {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
  
    const response = await fetch(`${process.env.REACT_APP_API_URL}/list-polst-docs?user_guid=${userGuid}`, {
      method: 'GET',
      headers: headers,
    });
  
    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);
  
    // Log raw response
    const responseText = await response.text();
    console.log('Raw response:', responseText);
  
    if (!response.ok) {
      throw new Error(`Failed to fetch documents: ${response.status}`);
    }
  
    try {
      const data = JSON.parse(responseText);
      console.log('Parsed data:', data);
      return data;
    } catch (parseError) {
      console.error('JSON parsing error:', parseError);
      throw new Error('Failed to parse response data');
    }

  };


export const GetSavedUserPhoto = async (userGuid, accessToken = null) => {
 try { 
  const headers = {
    'Accept': 'application/json',
    'User-Guid': userGuid,
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}/get-user-photo?user_guid=${userGuid}`, {
    method: 'GET',
    headers: headers,
  });

  if (!response.ok) {
    throw new Error('Failed to fetch user photo from storage');
  }

    return response.json(); 
  
  } catch (error) {
    console.error('Error in GetSavedUserPhoto API:', error);
    throw error;
  }
  
};

  /*
  export const downloadDocument = async (userGuid, fileName, accessToken = null) => {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
  
    const response = await fetch(`${process.env.REACT_APP_API_URL}/download-polst?user_guid=${userGuid}&file_name=${fileName}`, {
      method: 'GET',
      headers: headers,
    });
  
    if (!response.ok) {
      throw new Error('Download failed');
    }
  
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };
*/
  export const downloadDocument = async (userGuid, fileName, accessToken = null) => {
    try {
      console.log(`Downloading document: ${fileName} for user: ${userGuid}`);
      
      // Get the presigned URL
      const downloadUrl = await getDocumentDownloadUrl(userGuid, fileName, accessToken);
      
      // Create a temporary link element
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = fileName; // This attribute tells the browser to download rather than navigate
      a.target = '_blank';   // Open in new tab (as fallback)
      document.body.appendChild(a);
      
      // Trigger the download
      a.click();
      
      // Clean up
      document.body.removeChild(a);
      
      return true;
    } catch (error) {
      console.error('Error in downloadDocument:', error);
      throw error;
    }
  };


  export const fetchProtectedData = async (endpoint, userGuid, accessToken) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'User-Guid': userGuid,
        'Accept': 'application/json',
      },
      credentials: 'include',
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch protected data');
    }
  
    return response.json();
  };
  


  export const uploadFile = async (userGuid, file, folderType, accessToken) => {
    // Step 1: Get presigned URL from backend
    const getPresignedUrl = await fetch(`${process.env.REACT_APP_API_URL}/get-presigned-url`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'User-Guid': userGuid,
        'folder-type': folderType,
        'filename': encodeURIComponent(file.name),
        'Content-Type': file.type || 'application/octet-stream'
      }
    });
  
    if (!getPresignedUrl.ok) {
      const error = await getPresignedUrl.json();
      throw new Error(error.message || 'Failed to get upload URL');
    }
  
    const { upload_url, file_path } = await getPresignedUrl.json();
  
    // Step 2: Upload file directly to S3 using the presigned URL
    const uploadResponse = await fetch(upload_url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/octet-stream'
      },
      body: file
    });
  
    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file to S3');
    }
  
    return {
      success: true,
      message: 'File uploaded successfully',
      file_path: file_path
    };
  };


  /*
  export const deleteDocument = async (userGuid, fileName, accessToken) => {
    try {
      // Check if fileName is defined
      if (!fileName) {
        console.error('Filename is undefined');
        return {
          success: false,
          message: 'Filename is missing'
        };
      }
  
      const fullPath = `${userGuid}/POLST/${fileName}`;
      console.log('Attempting to delete file:', fullPath); 
  
      // Create headers object similar to your other API functions
      const headers = {
        'Content-Type': 'application/json',
        'user-guid': userGuid,
        //'user-guid': userGuid
      };
  
      // Add Authorization header if accessToken exists
      if (accessToken) {
        headers['Authorization'] = accessToken;  // Don't add 'Bearer ' prefix
      }
  
      console.log('Request headers:', headers);
  
      const response = await fetch(`${process.env.REACT_APP_API_URL}/delete-document`, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify({
          file_name: fullPath,
          user_guid: userGuid
        })
      });
  
      // Log the response status for debugging
      console.log('Delete response status:', response.status);
      
      // Get response as text first for debugging
      const responseText = await response.text();
      console.log('Raw delete response:', responseText);
      
      // Parse the response if it's JSON
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        console.error('Error parsing response:', e);
        data = { message: responseText || 'Unknown error' };
      }
      
      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete document');
      }
      
      return {
        success: true,
        message: data.message || 'Document deleted successfully'
      };
    } catch (error) {
      console.error('Error deleting document:', error);
      return {
        success: false,
        message: error.message || 'Error deleting document'
      };
    }
  };

  */

// New functions for consolidated preipresignedURL lambda for File CRUD operations

// Function to get a presigned URL for uploading a document
export const getUploadUrl = async (userGuid, fileName, contentType, accessToken = null) => {
  try {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
      'operation': 'upload',
      'folder-type': 'POLST',
      'filename': fileName,
      'content-type': contentType
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get-presigned-url`, {
      method: 'POST',
      headers: headers
    });
  
    if (!response.ok) {
      throw new Error('Failed to get upload URL');
    }
    
    const data = await response.json();
    
    if (!data.success || !data.upload_url) {
      throw new Error('Invalid upload URL response');
    }
    
    return data.upload_url;
  } catch (error) {
    console.error('Error getting upload URL:', error);
    throw error;
  }
};

// Function to get a presigned URL for downloading a document
export const getDocumentDownloadUrl = async (userGuid, fileName, accessToken = null) => {
  try {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
      'operation': 'download',
      'folder-type': 'POLST',
      'filename': fileName
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get-presigned-url`, {
      method: 'POST',
      headers: headers
    });
  
    if (!response.ok) {
      throw new Error('Failed to get download URL');
    }
    
    const data = await response.json();
    
    if (!data.success || !data.download_url) {
      throw new Error('Invalid download URL response');
    }
    
    return data.download_url;
  } catch (error) {
    console.error('Error getting download URL:', error);
    throw error;
  }
};

// Function to get a presigned URL for viewing a document
export const getDocumentViewUrl = async (userGuid, fileName, accessToken = null) => {
  try {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
      'operation': 'fetch',
      'folder-type': 'POLST',
      'filename': fileName
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get-presigned-url`, {
      method: 'POST',
      headers: headers
    });
  
    if (!response.ok) {
      throw new Error('Failed to get view URL');
    }
    
    const data = await response.json();
    
    if (!data.success || !data.view_url) {
      throw new Error('Invalid view URL response');
    }
    
    return data.view_url;
  } catch (error) {
    console.error('Error getting view URL:', error);
    throw error;
  }
};

// Function to delete a document
export const deleteDocumentViaPresignedUrl = async (userGuid, fileName, accessToken = null) => {
  try {
    const headers = {
      'Accept': 'application/json',
      'User-Guid': userGuid,
      'operation': 'delete',
      'folder-type': 'POLST',
      'filename': fileName
    };
  
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get-presigned-url`, {
      method: 'POST',
      headers: headers
    });
  
    if (!response.ok) {
      throw new Error('Failed to delete document');
    }
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to delete document');
    }
    
    return {
      success: true,
      message: data.message || 'Document deleted successfully'
    };
  } catch (error) {
    console.error('Error deleting document:', error);
    return {
      success: false,
      message: error.message || 'Error deleting document'
    };
  }
};





  export const createCheckoutSession = async (userGuid, accessToken) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'User-Guid': userGuid
        }
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create checkout session');
      }
  
      return await response.json();
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  };
  
  //likely not needed as we are moving to sessionID verification
  export const verifyPaymentStatus = async (userGuid, accessToken) => {
    try {
      const response = await fetchProtectedData('/get-user', userGuid, accessToken);
      return response.Paid_Status === 'True' || response.Paid_Status === true;
    } catch (error) {
      console.error('Error verifying payment status:', error);
      return false;
    }
  };

  export const verifyPaymentBySession = async (sessionId, userGuid = null) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-payment-by-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          sessionId,
          userGuid,
        })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to verify payment');
      }
  
      const data = await response.json();
      return data.paymentVerified;
    } catch (error) {
      console.error('Error verifying payment by session:', error);
      return false;
    }
  };